import { render, staticRenderFns } from "./CSacola.vue?vue&type=template&id=779b7dd4&scoped=true"
import script from "./CSacola.vue?vue&type=script&lang=js"
export * from "./CSacola.vue?vue&type=script&lang=js"
import style0 from "./CSacola.vue?vue&type=style&index=0&id=779b7dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779b7dd4",
  null
  
)

export default component.exports